import { useCallback, useRef, useState } from "react";

// O teclado nas marcas de um grafico (spec do RPAA-286, decisao 12: o foco, o teclado e o nome de cada
// marca sao nossos). Um so ponto de tabulacao por grafico, o da marca ativa; as setas andam entre as
// marcas, e Home e End vao a primeira e a ultima.
const MOVES = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };

const useArrowFocus = (count) => {
  const marks = useRef([]);
  const [chosen, setActive] = useState(0);
  // Uma serie que encolheu (outro periodo) nao pode deixar o grafico sem ponto de tabulacao.
  const active = Math.min(chosen, Math.max(0, count - 1));

  const refFor = (index) => (element) => {
    marks.current[index] = element;
  };

  const onKeyDown = useCallback(
    (index, event) => {
      let next;
      if (event.key in MOVES) next = Math.min(count - 1, Math.max(0, index + MOVES[event.key]));
      else if (event.key === "Home") next = 0;
      else if (event.key === "End") next = count - 1;
      else return;
      event.preventDefault();
      setActive(next);
      marks.current[next]?.focus();
    },
    [count]
  );

  return { active, setActive, refFor, onKeyDown };
};

export default useArrowFocus;
